




































import { Vue, Prop, Component } from 'vue-property-decorator'
import vueSlider from 'vue-slider-component'
import AudioPromise from '@ivy/fts/audioPromise'
let audioPromise = null
@Component({
  components: {
    vueSlider
  }
})
export default class AudioModal extends Vue {
  @Prop() lessonDetail
  @Prop() hasAccess
  @Prop() finishRate
  slider = { // 控制进度条部分
    curValue: 0,
    height: 4,
    dotWidth: 15,
    dotHeight: 15,
    bgStyle: {
      backgroundColor: "#fff",
      height: "0.12rem"
    },
    processStyle: {
      backgroundColor: "#00B097"
    },
    sliderStyle: {
      backgroundColor: "#00B097",
      boxShadow: "none"
    }
  }
  audiosComp: any = null
  processWidth = 50
  currentTime: any = 0
  durationFormate: any = "00:00"
  totalDuration: any = Date.formatMs(this.lessonDetail.duration * 1000, "mm:ss")
  playing: boolean = false
  hasAcount: any = false
  hasAcountFinish: any = false
  playRates = [0.5, 1, 1.5, 2]
  curPlayRateIndex = 1
  canPlay: boolean = true
  actived: boolean = false
  get currentTimeFormation() {
    return Date.formatMs(this.slider.curValue * 1000, "mm:ss") || '00:00'
  }
  async mounted() {
    audioPromise = new AudioPromise(this.lessonDetail.lesson_url, e => this.updateTime(e), e => this.updateStatus(e))
    audioPromise && await this.playAudio(0)
    this.$emit('playDurationPoint', 'play')
  }
  async beforeDestroy() {
    await audioPromise.pause()
  }
  async playAudio(pos) {
    if (!this.hasAccess) {
      return this.showBuyPrompt()
    }
    if (this.playing) {
      this.$emit('playDurationPoint', 'pause')
      return this.pause()
    }
    if (!this.hasAcount) {
      this.hasAcount = true
      this.$emit('addPlayCount')
    }
    this.playing = true
    this.$emit('playDurationPoint', 'play')
    let r = await audioPromise.play(this.currentTime || 0)
  }
  async pause() {
    this.playing = false
    await audioPromise.pause()
  }
  changeSlider(event) {
    if (!this.hasAccess) {
      return this.showBuyPrompt()
    }
    let pos = parseInt(`${this.lessonDetail.duration / (100 / event)}`, 10)
    this.playing = true
    audioPromise.play(pos)
  }
  async updateTime(e) {
    if (!this.canPlay && e.target.currentTime >= 0) {
      this.canPlay = true
      this.playing = true
    }
    let duration = e.target.duration || +this.lessonDetail.duration
    this.durationFormate = Date.formatMs(e.target.currentTime * 1000, "mm:ss")
    this.currentTime = e.target.currentTime
    this.slider.curValue = parseInt(`${(e.target.currentTime / duration) * 100}`, 10)
    let rate = e.target.currentTime / duration
    if (+rate >= +this.finishRate && !this.hasAcountFinish) {
      this.hasAcountFinish = true
      this.$emit("accountPlayFinish")
    }
  }
  updateStatus(e) {
    if (e === 'paused') {
      this.playing = false
    } else if (e === 'ended') {
      this.durationFormate = "00:00"
      this.slider.curValue = 0
      this.playing = false
      this.currentTime = 0
      this.$emit("togglePlay", 1, true)
    }
  }
  showBuyPrompt() {
    this.$emit('showBuyPrompt')
  }
  togglePlayRate() {
    let curPlayRateIndex = this.curPlayRateIndex === this.playRates.length - 1 ? 0 : this.curPlayRateIndex + 1
    this.curPlayRateIndex = curPlayRateIndex
    audioPromise.playbackRates = this.playRates[curPlayRateIndex]
  }
}
